import { createContext } from "react";

import type { SessionModel } from "context/session/sessionTypes";

type SessionContext = SessionModel & { updateSession: (callback: (state: SessionModel) => SessionModel) => void };

export const sessionContext = createContext<SessionContext | undefined>(undefined);
